<!--
  启用 / 停用开关（与原型 .switch 一致）
  说明：不使用 el-switch，是因为它内部会先自行切换状态，
        在「先二次确认再生效」的场景下会出现视觉与数据不一致。
        这里改成纯展示组件，状态完全由 value 驱动，点击只抛事件。
-->
<template>
  <span
    class="tsw"
    :class="{ on: value }"
    :title="title"
    role="switch"
    @click="$emit('click')"
  >
    <span class="knob" />
  </span>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    /** 当前开关状态 */
    value: { type: Boolean, default: false },
    /** 开启时的悬浮提示 */
    onText: { type: String, default: '' },
    /** 关闭时的悬浮提示 */
    offText: { type: String, default: '' }
  },
  computed: {
    /** 按当前状态返回对应的悬浮提示 */
    title() {
      return this.value ? this.onText : this.offText;
    }
  }
};
</script>

<style scoped lang="scss">
.tsw {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 18px;
  border-radius: 9px;
  background: #c9cdd4;
  cursor: pointer;
  transition: background 0.2s;
  vertical-align: middle;
}
.tsw.on {
  background: #00a551;
}
.tsw .knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  transition: left 0.2s;
}
.tsw.on .knob {
  left: 18px;
}
</style>
